import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { BulkCompleteAppointmentsRequest } from '../../../../api-service/clients';
import { ConfirmCompleteAppointmentsDialogComponent } from './confirm-complete-appointments-dialog-component';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';

export interface IConfirmCompleteTasksDialogProps {
  appointmentIds?: string[];
}

export function ConfirmCompleteAppointmentsDialog({ appointmentIds }: IConfirmCompleteTasksDialogProps) {
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const handleConfirm = async () => {
    const request: BulkCompleteAppointmentsRequest = {
      appointmentIds,
    };
    try {
      await moduleClientFactory.createCompanyAppointmentClient().bulkCompleteAppointments(request);
      enqueueSnackbar('Alle aftaler blev afsluttet', { variant: 'success' });
    } catch (_) {
      enqueueSnackbar('Ikke alle aftaler blev afsluttet', { variant: 'error' });
    }
    setIsOpen(false);
  };

  function handleClose() {
    setIsOpen(false);
  }

  return <ConfirmCompleteAppointmentsDialogComponent isOpen={isOpen} selectedCount={appointmentIds?.length ?? 0} onCancelClick={handleClose} onConfirmClick={handleConfirm} />;
}
